<template>
  <div>
    <confirm-modal
        v-model="modalEstorno"
        @modalAcaoCancelar="fecharModalEstorno"
        @modalAcaoConfirmar="estornarCobranca"
        :persistencia="false"
        :maxWidth="500"
        textConfirmar="Confirmar"
        mensagemInicial="Deseja realmente estornar o pagamento no valor de "
        :mensagemMeio="dadosGerais.valorPago | valorParaReal"
        mensagemFinal=" dessa cobrança?"/>
    <confirm-modal
        v-model="modalExcluirPagamento"
        @modalAcaoCancelar="fecharModalExcluiPagamento"
        @modalAcaoConfirmar="tratarEventoExcluirPagamento"
        :persistencia="false"
        :maxWidth="500"
        textConfirmar="Confirmar"
        mensagemInicial="Deseja realmente excluir o pagamento no valor de "
        :mensagemMeio="pagamentoSelecionado.valorPago | valorParaReal"
        mensagemFinal="?"
    />
    <confirm-mensagem-modal
        v-model="modalCancelar"
        @modalAcaoCancelar="fecharModalCancelar"
        @modalAcaoConfirmar="tratarEventoCancelarCobranca"
        :persistencia="false"
        :maxWidth="600"
        :placeholder="null"
        :tamanho-maximo="300"
        textConfirmar="Confirmar"
        mensagemInicial="Informe a justificativa do cancelamento da cobrança no valor de "
        :mensagemMeio="dadosGerais.valorTotal | valorParaReal"
        mensagemFinal="."
    />
    <v-dialog v-model="model" max-width="800" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>
            Cobrança <strong>{{ dadosGerais.codigo }}</strong>
          </v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <div v-if="exibirPaciente" class="container-card-paciente tertiary">
            <div class="container-acessar-ficha">
              <div>
                <span style="font-size: 14px">Nome</span><br/>
                <p class="d-inline-block text-truncate max-text">{{ dadosGerais.pacienteNome }}</p>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" @click="acessarFichaPaciente" icon color="primary">
                    <v-icon size="50">mdi-account-box</v-icon>
                  </v-btn>
                </template>
                Acessar ficha do paciente
              </v-tooltip>
            </div>
            <span style="font-size: 14px">CPF/CNPJ</span>
            <p>{{ dadosGerais.pacienteCnpjCpf | formatarCpfCnpj }}</p>
          </div>
          <v-row wrap align-center white class="pl-2 pr-1" v-if="dadosGerais.orcamentoId">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div class="container-cobranca-orcamento">
                <span class="cobranca-codigo-orcamento">{{ dadosGerais.codigoOrcamento }}</span>
                <span
                    class="cobranca-status-orcamento">{{
                    dadosGerais.statusOrcamento | filterEnum(statusOrcamento)
                  }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row wrap align-center white class="pl-2 pr-1">
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                  v-model="dadosGerais.descricao"
                  name="descricao"
                  placeholder="Informe a descrição"
                  counter="100"
                  maxlength="100"
                  v-validate="{max: 250}"
                  :error-messages="errors.collect('descricao')">
                <template v-slot:label>
                  Descrição
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <date-input
                  v-model="dadosGerais.dataVencimento"
                  label="Data vencimento"
                  name-date="dataVencimento"
                  placeholderDate="Informe a data de vencimento">
              </date-input>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                  v-model="dadosGerais.observacao"
                  name="observacao"
                  label="Observação"
                  placeholder="Informe a observação"
                  v-validate="{max: 400}"
                  :error-messages="errors.collect('observacao')"
                  counter
                  filled
                  auto-grow
              />
            </v-col>
          </v-row>
          <div class="container-info-pagamento">
            <div v-if="dadosGerais.status === 'CANCELADA'" class="container-justificativa-cancelamento">
              <label>Justificativa do cancelamento:</label><br/>
              <span>{{ dadosGerais.justificativaCancelamento }}</span>
            </div>
            <div v-else class="container-pagamentos">
              <div class="container-pagamentos-action">
                <span class="primary--text" style="font-weight: bold;">Pagamentos</span>
                <v-tooltip top>
                  <template v-slot:activator={on}>
                    <v-btn v-on="on" color="primary" fab depressed small @click="adicionarPagamento"
                           :disabled="dadosGerais.status === 'PAGO'">
                      <v-icon v-if="addPagamento">mdi-close</v-icon>
                      <v-icon v-else>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  {{ addPagamento ? 'Cancelar' : 'Adicionar pagamento' }}
                </v-tooltip>
              </div>
              <div>
                <div class="pagamento-add" v-if="addPagamento">
                  <input-valor
                      v-model="novoPagamento.valorPago"
                      label="Valor"
                      placeholder="Informe o valor"
                      :event-submit="'blur'"
                      :prefix="prefixo"
                      :suffix="sufixo"
                      :precision="casasDecimais"
                      hide-details
                      @blur="(valor) => novoPagamento.valorPago = valor"
                      class-name="input-add-pagamento"
                  />
                  <combo-enum
                      v-model="novoPagamento.formaPagamento"
                      name="formaPagamento"
                      :enum-object="formasPagamento"
                      :insertNullItem="false"
                      hide-details
                      outlined
                      class-name="input-forma-pagamento"
                  >
                    <template v-slot:label>
                      Forma de pagamento
                    </template>
                  </combo-enum>
                  <v-tooltip top>
                    <template v-slot:activator={on}>
                      <v-btn v-on="on" color="primary" class="ml-1" icon small @click="confirmarAdicionarPagamento">
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    Confirmar
                  </v-tooltip>
                </div>
                <div class="container-pagamentos-list">
                  <campo-pagamento-editavel
                      :key="pagamento.id" v-for="pagamento in pagamentos"
                      :value="pagamento"
                      :name="'pagItem' + pagamento.id"
                      @excluirPagamento="abrirModalExcluiPagamento"
                      @editarPagamento="editarPagamento"
                  />
                </div>
              </div>
            </div>
            <div>
              <div class="container-cobranca-valor-total">
                <span class="titulo-valor-cobranca">Valor da Cobrança</span>
                <span class="text-valor-cobranca">{{ dadosGerais.valorTotal | valorParaReal }}</span>
              </div>
              <div class="container-cobranca-status">
                <span v-if="dadosGerais.status === 'PENDENTE'" style="text-align: center">Pagamento pendente!</span>
                <span v-if="dadosGerais.status === 'PAGO'" style="text-align: center">
                    <span :class="['status-cobranca-' + dadosGerais.status]">Pago em</span><br/>
                 {{ dadosGerais.dataPagamento | filterDataHora }}
               </span>
                <div v-if="dadosGerais.status === 'CANCELADA'" style="text-align: center">
                  <span :class="['status-cobranca-' + dadosGerais.status]">Cancelado em</span><br/>
                  <label>{{ dadosGerais.dataCancelamento | filterDataHora }}</label>
                </div>
                <div v-if="dadosGerais.status === 'PARCIALMENTE_PAGO'" class="container-cobranca-parcial">
                  <span class="ml-2">Pago</span>
                  <label class="ml-2">{{ dadosGerais.valorPago | valorParaReal }}</label>
                  <div class="linha-horizontal"/>
                  <span class="ml-2">Restante</span>
                  <label class="ml-2">{{ dadosGerais.valorRestante | valorParaReal }}</label>
                </div>
                <div v-if="dadosGerais.dataEstorno" style="text-align: center">
                  <span>Estornado em</span><br/>
                  <label>{{ dadosGerais.dataEstorno | filterDataHora }}</label>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-container>
          <v-row wrap align-center white class="pl-10 pr-10 row-bottom">
            <botao-cancelar @cancelar="fecharModal" text="Voltar"/>
            <div style="display: flex; flex-direction: row">
              <v-tooltip top v-if="!estornar && dadosGerais.status != 'CANCELADA'">
                <template v-slot:activator={on}>
                  <v-btn
                      v-on="on"
                      id="botaoCancelarCobranca"
                      class="mr-5 btn-cancelar-cobranca"
                      outlined
                      @click="abrirModalCancelar">
                    <v-icon>mdi-cancel</v-icon>
                    Cancelar
                  </v-btn>
                </template>
                Cancelar cobrança
              </v-tooltip>
              <v-tooltip top v-if="estornar">
                <template v-slot:activator={on}>
                  <v-btn
                      v-on="on"
                      id="botaoEstonar"
                      color="alert"
                      class="mr-5 botao-estornar-cobranca"
                      outlined
                      @click="abrirModalEstorno">
                    <v-icon>mdi-cancel</v-icon>
                    Estornar
                  </v-btn>
                </template>
                Estornar cobrança
              </v-tooltip>
              <botao-salvar @salvar="tratarEventoEdicao"/>
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import moment from 'moment/moment'
import {actionTypes} from '@/core/constants'
import {statusOrcamento, statusCobranca} from '@/core/constants'
import BotaoSalvar from '@/views/components/BotaoSalvar.vue'
import BotaoCancelar from '@/views/components/BotaoCancelar.vue'
import DateInput from '@/views/components/DateInput.vue'
import InputValor from '@/views/components/InputValor.vue'
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import ComboEnum from '@/views/components/ComboEnum.vue'
import formasPagamento from '@/core/constants/enums/formasPagamento'
import CampoPagamentoEditavel from '@/views/components/camposEditaveis/campo-pagamento-editavel.vue'
import ConfirmMensagemModal from '@/views/components/ConfirmMessageModal.vue'

export default {
    name: 'CobrancaEdicaoModal',
    components: {
        ConfirmMensagemModal,
        CampoPagamentoEditavel, ComboEnum, ConfirmModal, InputValor, DateInput, BotaoCancelar, BotaoSalvar
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        idCobranca: Number,
        exibirPaciente: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dadosGerais: {
                id: null,
                codigo: '',
                pacienteId: null,
                valorTotal: null,
                valorPago: null,
                status: 'PENDENTE',
                descricao: null,
                observacao: null,
                dataVencimento: null,
                orcamentoId: null,
                codigoOrcamento: null,
                statusOrcamento: null,
                valorRestante: null,
                pacienteNome: null,
                pacienteCnpjCpf: null,
                justificativaCancelamento: null
            },
            pagamentos: [],
            prefixo: 'R$',
            sufixo: '',
            casasDecimais: 2,
            statusOrcamento,
            statusCobranca,
            estornar: false,
            modalEstorno: false,
            modalCancelar: false,
            addPagamento: false,
            formasPagamento,
            novoPagamento: {
                cobrancaId: null,
                pacienteId: null,
                valorPago: null,
                formaPagamento: null,
            },
            pagamentoSelecionado: {
                id: null,
                valorPago: null,
                formaPagamento: null
            },
            modalExcluirPagamento: false,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    async mounted() {
        await this.buscarCobranca()
        await this.buscarPagamentos()
    },
    methods: {
        async buscarCobranca() {
            const resultado = await this.$store.dispatch(actionTypes.COBRANCA.BUSCAR_COBRANCA_POR_ID, this.idCobranca)
            if (resultado) {
                this.dadosGerais = resultado
                if (this.dadosGerais.status === 'PAGO') {
                    this.estornar = true
                }
            }
        },
        async buscarPagamentos() {
            const resultado = await this.$store.dispatch(actionTypes.PAGAMENTO.BUSCAR_PAGAMENTOS_POR_COBRANCA_ID, this.idCobranca)
            if (resultado) {
                this.pagamentos = resultado.items
            }
        },
        adicionarPagamento() {
            this.addPagamento = !this.addPagamento
        },
        async confirmarAdicionarPagamento() {

            if (!this.novoPagamento.valorPago) {
                this.mostrarNotificacaoErro('Informe o valor a ser pago!')
                return
            }
            if (this.novoPagamento.valorPago > this.dadosGerais.valorTotal) {
                this.mostrarNotificacaoErro('O valor pago é maior que o valor cobrado!')
                return
            }
            if (!this.novoPagamento.formaPagamento) {
                this.mostrarNotificacaoErro('Informe a forma de pagamento!')
                return
            }

            this.novoPagamento.cobrancaId = this.dadosGerais.id
            this.novoPagamento.pacienteId = this.dadosGerais.pacienteId
            this.setMensagemLoading('Adicionando pagamento...')
            await this.$store.dispatch(actionTypes.PAGAMENTO.CADASTRAR_PAGAMENTO, this.novoPagamento)
            await this.buscarPagamentos()
            await this.buscarCobranca()
            this.mostrarNotificacaoSucessoDefault()
            this.addPagamento = false
            this.novoPagamento.valorPago = null
            this.novoPagamento.formaPagamento = null
        },
        formatarData() {
            if (this.dadosGerais.dataVencimento) {
                this.dadosGerais.dataVencimento = moment(this.dadosGerais.dataVencimento).add(5, 'hours').format('YYYY-MM-DD')
            }
        },
        async tratarEventoEdicao() {
            if (await this.validarDadosFormulario()) {
                this.formatarData()
                this.setMensagemLoading('Editando registro de cobrança...')
                await this.$store.dispatch(actionTypes.COBRANCA.EDITAR_COBRANCA, this.dadosGerais)
                this.mostrarNotificacaoSucessoDefault()
                await this.buscarCobranca()
            }
        },
        async editarPagamento(pagamento) {
            await this.$store.dispatch(actionTypes.PAGAMENTO.EDITAR_PAGAMENTO, pagamento)
            await this.buscarCobranca()
            await this.buscarPagamentos()
            this.setMensagemLoading('Editando pagamento...')
            this.mostrarNotificacaoSucessoDefault()
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalEdicao')
        },
        abrirModalEstorno() {
            this.modalEstorno = true
        },
        fecharModalEstorno() {
            this.modalEstorno = false
        },
        abrirModalCancelar() {
            this.modalCancelar = true
        },
        fecharModalCancelar() {
            this.modalCancelar = false
        },
        abrirModalExcluiPagamento(pagamento) {
            this.pagamentoSelecionado = pagamento
            this.modalExcluirPagamento = true
        },
        fecharModalExcluiPagamento() {
            this.pagamentoSelecionado = {id: null, valorPago: null, formaPagamento: null}
            this.modalExcluirPagamento = false
        },
        async tratarEventoCancelarCobranca(justificativa) {

            if (!justificativa) {
                this.mostrarNotificacaoErro('Informe a justificativa do cancelamento!')
                return
            }

            const input = {
                id: this.idCobranca,
                justificativa: justificativa
            }
            await this.$store.dispatch(actionTypes.COBRANCA.CANCELAR_COBRANCA, input)
            this.mostrarNotificacaoSucessoDefault()
            await this.buscarCobranca()
            this.fecharModalCancelar()
        },
        async estornarCobranca() {
            await this.$store.dispatch(actionTypes.COBRANCA.ESTORNAR_COBRANCA, this.idCobranca)
            await this.buscarCobranca()
            await this.buscarPagamentos()
            this.mostrarNotificacaoSucessoDefault()
            this.estornar = false
            this.fecharModalEstorno()
        },
        async tratarEventoExcluirPagamento() {
            await this.$store.dispatch(actionTypes.PAGAMENTO.EXCLUIR_PAGAMENTO, this.pagamentoSelecionado.id)
            await this.buscarCobranca()
            await this.buscarPagamentos()
            this.mostrarNotificacaoSucessoDefault()
            this.fecharModalExcluiPagamento()
        },
        acessarFichaPaciente() {
            this.$router.push({name: 'PacienteFicha', params: {id: this.dadosGerais.pacienteId}})
        }
    }
}
</script>

<style scoped lang="stylus">

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  display flex
  justify-content space-between

.container-cobranca-orcamento
  background-color #E0E0E0
  padding 10px 20px
  border-radius 5px
  display flex
  flex-direction row
  justify-content space-between

.cobranca-codigo-orcamento
  font-weight bold

.cobranca-status-orcamento
  color #f44336

.container-cobranca-valor-total
  display flex
  flex-direction column

.titulo-valor-cobranca
  font-weight bold

.container-cobranca-status
  font-weight bold
  font-size 18px
  background-color #E0E0E0
  display flex
  flex-direction column
  justify-content center
  align-items center
  border-radius 5px
  padding 5px
  min-width 200px

  div
    margin-top 2px

.container-cobranca-parcial
  display flex
  flex-direction column
  width 100%

  span
    font-size 15px

.botao-estornar-cobranca
  color #fff

.linha-horizontal
  width 100%
  height 1px
  background-color #5A5A5A

.container-card-paciente
  border-radius 5px
  padding 5px
  margin-bottom 10px

  span
    font-weight bold
    color #f5f5f5
    font-size 14px

  p
    color #f1f3f4

.container-acessar-ficha
  display flex
  justify-content space-between

.max-text
  max-width 15vw

.btn-cancelar-cobranca
  color #999 !important

.container-info-pagamento
  display flex
  flex-direction row
  justify-content space-between
  border 1px solid #ddd
  border-radius 5px
  padding 5px
  margin 0 5px

.container-pagamentos
  width 100%
  margin-right 30px

.container-pagamentos-action
  width 100%
  display flex
  justify-content space-between
  align-items center

.container-pagamentos-list
  overflow-y scroll
  max-height 100px
  margin-top 10px

.botao-excluir-pagamento:hover
  color red !important

.pagamento-add
  display flex
  align-items center
  padding 5px 2px
  border-bottom 1px solid #ddd
  margin-top 10px

.input-add-pagamento
  height 40px !important
  width 120px

  >>> .v-label
    top 7px

  >>> .v-label--active
    -webkit-transform translateY(-14px) scale(0.75)
    transform translateY(-14px) scale(0.75)

  >>> .v-input__slot
    min-height 40px !important

.input-forma-pagamento
  margin-left 10px
  width 200px

.container-justificativa-cancelamento
  label
    font-weight bold

@media (max-width: 900px)
  .container-info-pagamento
    flex-direction column

  .container-pagamentos
    margin-right 0px

</style>